import React from "react";
import Heading from "../../components/Heading";
import IconButton from "../../components/IconButton";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import SelectArticle from "./Progress/SelectArticle";
import UploadTemplates from "./Progress/UploadTemplates";
import DefineAreas from "./Progress/DefineAreas";
import DetermineSurchargeType from "./Progress/DetermineSurchargeType";
import NavButtons from "./Progress/NavButtons";
import {useIndividualizationContext} from "../../contexts/individualizationContext";
import {useTranslation} from "react-i18next";
import ProgressBar from "./Progress/ProgressBar";
import ErrorBar from "./Progress/ErrorBar";

const EditIndividualization: React.FC = () => {
    const {currentTab, changeCurrentTab} = useIndividualizationContext()
    const { t } = useTranslation(['individualization'])

    return currentTab === 3 ? (
        <div>
            <Heading level={2} classes={'mt-4'}>{t('headings.edit')}</Heading>
            <div className={'mb-4'}>
                <IconButton
                    icon={faArrowLeft}
                    color={'black'}
                    onClick={() => changeCurrentTab(1)}
                >
                    {t('common.backToOverview')}
                </IconButton>
            </div>
            <ProgressBar/>
            <ErrorBar/>
            <SelectArticle/>
            <UploadTemplates/>
            <DefineAreas/>
            <DetermineSurchargeType/>
            <NavButtons method={"update"}/>
        </div>
    ): null
}
export default EditIndividualization
